const s = {
  name: "CurrencyBahrainiDinarV2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,11h-5v18h5c2.8,0,5-2.2,5-5v-8C32,13.2,29.8,11,27,11z M27,27h-3V13h3c1.7,0,3,1.3,3,3v8
			C30,25.7,28.7,27,27,27z"/>
		<path class="st0" d="M9,11h6c2.8,0,5,2.2,5,5c0,1.6-0.8,3.1-2,4c1.2,0.9,2,2.4,2,4c0,2.8-2.2,5-5,5H9V11z M11,19h4
			c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3h-4V19z M11,21v6h4c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3H11z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyBahrainiDinarV2
};
